import askModalUrl from './askModal.html';

class AskModalController {
  $onInit() {
    const defaults = {
      cancel: 'Cancel',
      confirm: 'Yes',
      title: 'Please confirm',
      type: 'danger',
    };

    if (typeof this.config === 'string') {
      this.modalConfig = Object.assign({}, defaults, { question: this.config });
    } else {
      this.modalConfig = Object.assign({}, defaults, this.config);
    }

    this.withCheckboxes = Boolean(this.modalConfig.conditions);
    this.conditionValues = [];
    this.withConfirm = Boolean(this.modalConfig.confirmText);
  }

  isConfirmationValid() {
    if (!this.withConfirm) {
      return true;
    }
    return this.confirmInput.toLowerCase() === this.modalConfig.confirmText.toLowerCase();
  }

  isFormValid() {
    return (
      !this.withCheckboxes ||
      (this.modalConfig.conditions.every((_, index) => this.conditionValues[index]) &&
        this.isConfirmationValid())
    );
  }

  showWarning() {
    return (
      (!this.form.confirmInput.$pristine || this.form.$submitted) && !this.isConfirmationValid()
    );
  }

  submit() {
    if (!this.withCheckboxes) {
      this.close();
    }

    if (this.form) {
      this.form.$setSubmitted();

      if (this.isFormValid()) {
        this.close();
      }
    }
  }
}

export default {
  controller: AskModalController,
  controllerAs: 'ctrl',
  templateUrl: askModalUrl,
  bindings: {
    config: '<',
    dismiss: '&',
    close: '&',
  },
};
